var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.subLabel)?_c('p',{staticClass:"text-gray-mid-light line-height-1"},[_vm._v(" "+_vm._s(_vm.subLabel)+" ")]):_vm._e(),_c('p',{staticClass:"margin-t-0 margin-b-1",class:{ 'text-gray-mid-light': _vm.disabled }},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('div',{staticClass:"h-8 w-full",class:{
      'background-primary': _vm.complete,
      'background-gray-mid-light': !_vm.complete,
    }})])
}
var staticRenderFns = []

export { render, staticRenderFns }